//const BACKEND_URL = "https://jcalvez.info/apps/merlin";
const BACKEND_URL = "https://merlin.wservers.info/apps/merlin";

export default BACKEND_URL;
